import React from 'react';
import {Col, Row} from 'react-bootstrap';

export const EmptyMessageDisplay = (props) => {
    const {
        ClearFilters: clearFilters = () => (false),
        HasFilters: hasFilters = false,
        ItemName: itemName = "items",
        message = null,
        usesContext = true,
        footer = null
    } = props;

    return (
        <Row>
            <Col xs={12} md={2}/>
            <Col xs={12} md={8} className="sb-no-items-warning">
                {
                    !!message && 
                    <div>
                        {message}
                    </div>
                }
                {
                    !message &&
                    ( hasFilters ?
                        <div>
                            No {itemName}{usesContext ? " at the current context" : ""} match your selected filters.<br/>
                            Try <a className="link-primary" onClick={clearFilters}>clearing your filters</a>.
                        </div> :
                        <div>
                            There are no {itemName} at the current context.
                        </div>
                    )
                }
                {
                    footer
                }
            </Col>
            <Col xs={12} md={2}/>
        </Row>
    );
};


